import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonFunctionsService, DialogType } from './common-functions.service';
import { NotificationType, SilentActions, } from './definitions.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/fire/messaging";
import * as i2 from "./common-functions.service";
import * as i3 from "./log.service";
import * as i4 from "./auth.service";
import * as i5 from "./data-model.service";
import * as i6 from "@angular/router";
var MessagingService = /** @class */ (function () {
    function MessagingService(angularFireMessaging, commonFunctions, log, authenticationService, dataModel, router) {
        this.angularFireMessaging = angularFireMessaging;
        this.commonFunctions = commonFunctions;
        this.log = log;
        this.authenticationService = authenticationService;
        this.dataModel = dataModel;
        this.router = router;
        this.currentMessage = new BehaviorSubject(null);
        this.isRequestingToken = new BehaviorSubject(false);
        this.unreadCount$ = of(0);
    }
    /** Call once after login to wire up the unread-count observable. */
    MessagingService.prototype.initInbox = function (userId) {
        this.unreadCount$ = this.dataModel
            .subscribeToInboxNotifications(userId)
            .pipe(map(function (notifications) { return notifications.filter(function (n) { return !n.read; }).length; }));
    };
    //Starts asking if user wants to receive push notification
    MessagingService.prototype.requestPermission = function (force) {
        if (force === void 0) { force = false; }
        if (this.authenticationService.isLoggedIn) {
            this.requestNotificationPermission(this.authenticationService.userDetails.uid, force);
        }
        else {
            this.commonFunctions.showErrorToast('User nicht eingeloggt');
        }
    };
    MessagingService.prototype.receiveMessage = function () {
        var _this = this;
        // Foreground messages (app is open): the notification is already saved to
        // Firestore by the sender script, so no saving is needed here. For silent
        // actions the app still needs to act immediately.
        this.angularFireMessaging.messages.subscribe(function (payload) {
            var p = payload;
            console.log('Message received. ', p);
            _this.currentMessage.next(p);
            _this.handleIncomingPayload(p);
        });
        // Background silent actions are broadcast by the service worker so the app
        // can execute them even when the push arrived while the tab was hidden.
        if (navigator.serviceWorker) {
            navigator.serviceWorker.addEventListener('message', function (event) {
                var _a, _b, _c, _d;
                var msg = event.data;
                if (!msg || !msg.payload)
                    return;
                if (msg.type === 'BACKGROUND_MESSAGE_RECEIVED') {
                    var payload = msg.payload;
                    var messageType = parseInt((_b = (_a = payload === null || payload === void 0 ? void 0 : payload.data) === null || _a === void 0 ? void 0 : _a.messageType) !== null && _b !== void 0 ? _b : '', 10) || 0;
                    if (messageType === NotificationType.SilentAction) {
                        _this.handleSilentActions(parseInt((_d = (_c = payload.data) === null || _c === void 0 ? void 0 : _c.silentActionId) !== null && _d !== void 0 ? _d : '', 10));
                    }
                }
            });
        }
    };
    /**
     * Handles a received foreground FCM payload.
     * The sender script already saved the notification to Firestore, so the
     * live inbox subscription will update automatically. Here we only need to
     * act on silent actions that require immediate in-app execution.
     */
    MessagingService.prototype.handleIncomingPayload = function (payload) {
        var _a, _b;
        var data = (payload === null || payload === void 0 ? void 0 : payload.data) || {};
        var messageType = parseInt((_a = data.messageType) !== null && _a !== void 0 ? _a : '', 10) || 0;
        if (messageType === NotificationType.SilentAction) {
            this.handleSilentActions(parseInt((_b = data.silentActionId) !== null && _b !== void 0 ? _b : '', 10));
            return;
        }
        // Navigate to the notifications inbox with the doc ID so the correct message opens.
        this.router.navigate(['/notifications'], {
            queryParams: data.notificationDocId ? { id: data.notificationDocId } : {},
        });
    };
    //Handles silent actions without any user notification
    MessagingService.prototype.handleSilentActions = function (silentActionId) {
        if (silentActionId === SilentActions.SendLogFilesToDev) {
            this.log
                .sendLogsToDev(this.authenticationService.userId)
                .then(function () { return console.log('Logs erfolgreich versandt'); }, function (rejectMsg) { return console.log('Logs nicht versandt: ' + rejectMsg); });
        }
        if (silentActionId === SilentActions.LogOut) {
            this.authenticationService.logout();
        }
        if (silentActionId === SilentActions.ClearLogFiles) {
            this.log.clearLogs();
        }
    };
    /**
     * Requests permission to retrieve web notifications
     * Source: https://github.com/angular/angularfire/blob/master/docs/messaging/messaging.md
     */
    MessagingService.prototype.requestNotificationPermission = function (userId, force) {
        var _this = this;
        if (force === void 0) { force = false; }
        //already requested?
        var alreadyRequested = localStorage.getItem('notiTokenRequested');
        if (alreadyRequested == null || force) {
            this.commonFunctions
                .openDialog('Benachrichtigungen', 'Möchtest du Push-Benachrichtigungen erhalten?', DialogType.INFO, 'Nein', 'Ja')
                .afterClosed()
                .subscribe(function (result) {
                localStorage.setItem('notiTokenRequested', 'true');
                if (result.result == 1) {
                    _this.isRequestingToken.next(true);
                    _this.angularFireMessaging.requestToken.subscribe(function (token) {
                        _this.isRequestingToken.next(false);
                        _this.log.debug('Permission for receiving notifications granted. Sending token to server', token, CommonFunctionsService.name);
                        _this.commonFunctions.saveNotiTokenInUserCollection(userId, token !== null && token !== void 0 ? token : '');
                    }, function (error) {
                        _this.isRequestingToken.next(false);
                        _this.commonFunctions.showErrorToast('Registrierung nicht möglich');
                        _this.log.error('Request for receiving notification token failed', error, CommonFunctionsService.name);
                    });
                }
            });
        }
    };
    MessagingService.ɵfac = function MessagingService_Factory(t) { return new (t || MessagingService)(i0.ɵɵinject(i1.AngularFireMessaging), i0.ɵɵinject(i2.CommonFunctionsService), i0.ɵɵinject(i3.LogService), i0.ɵɵinject(i4.AuthService), i0.ɵɵinject(i5.DataModelService), i0.ɵɵinject(i6.Router)); };
    MessagingService.ɵprov = i0.ɵɵdefineInjectable({ token: MessagingService, factory: MessagingService.ɵfac, providedIn: 'root' });
    return MessagingService;
}());
export { MessagingService };
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessagingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: i1.AngularFireMessaging }, { type: i2.CommonFunctionsService }, { type: i3.LogService }, { type: i4.AuthService }, { type: i5.DataModelService }, { type: i6.Router }]; }, null); })();
//# sourceMappingURL=messaging.service.js.map